module.exports = __webpack_public_path__ + "static/media/3x2 b.79b717da.kra";